// extracted by mini-css-extract-plugin
module.exports = {"Main":"Alert-module--Main--14Sg6","Link":"Alert-module--Link--14Wg3"};